import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';
import siteConfig from '@/config/site';
import { meta } from '@/documents/blogs.js';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export const constRoutesPc = [
  {
    path: '/',
    name: 'en-home',
    meta: meta(
      'WhatsApp Aero APK Download v10.9 Latest Version 2026 | Anti-Ban & Official',
      'Download WhatsApp Aero APK latest version v10.9 for Android. Explore advanced privacy features, custom themes, anti-delete messages, installation guides, updates, comparisons, and FAQs.',
      'WhatsApp Aero, WhatsApp Aero APK',
      '/'
    ),
    component: Home,
  },
  {
    path: '/download',
    name: 'en-download',
    meta: meta(
      'Download WhatsApp Aero APK for Android 2026 | Latest Stable Version',
      'Download WhatsApp Aero APK latest version 2026 for Android. Get the stable installation file with improved privacy features, custom themes, anti-delete messages, and step-by-step install guide.',
      '',
      '/download/'
    ),
    component: () => import('@/views/download.vue'),
  },
  {
    path: '/features',
    name: 'en-features',
    meta: meta(
      'WhatsApp Aero Features – Privacy, Themes & Customization Tools',
      'Explore WhatsApp Aero features including advanced privacy controls, custom themes, anti-delete messages, chat lock, and enhanced media sharing tools for Android users.',
      'WhatsApp Aero Features',
      '/features/'
    ),
    component: () => import('@/views/features.vue'),
  },
  {
    path: '/install-whatsapp-aero-apk',
    name: 'en-install',
    meta: meta(
      'How to Install WhatsApp Aero APK on Android',
      'Step-by-step guide to install WhatsApp Aero APK on Android devices. Learn how to enable unknown sources, install APK, and set up your account safely.',
      'WhatsApp Aero Install, Install WhatsApp Aero APK, WhatsApp Aero Setup Guide',
      '/install-whatsapp-aero-apk/'
    ),
    component: () => import('@/views/install.vue'),
  },
  {
    path: '/update-whatsapp-aero',
    name: 'en-update',
    meta: meta(
      'How to Update WhatsApp Aero to Latest Version 2026',
      'Learn how to update WhatsApp Aero safely to the latest version without losing chats. Includes backup steps and installation guide.',
      'WhatsApp Aero Update, Update WhatsApp Aero APK, WhatsApp Aero Latest Version Update',
      '/update-whatsapp-aero/'
    ),
    component: () => import('@/views/update.vue'),
  },
  {
    path: '/how-to-stay-safe',
    name: 'en-antiban',
    meta: meta(
      'WhatsApp Aero Anti-Ban Guide – How to Stay Safe',
      'Understand WhatsApp Aero anti-ban protection, safety tips, and how to reduce the risk of account suspension while using modded WhatsApp apps.',
      'WhatsApp Aero Anti Ban, WhatsApp Aero Safety, WhatsApp Aero Ban Protection',
      '/how-to-stay-safe/'
    ),
    component: () => import('@/views/antiban.vue'),
  },
  {
    path: '/blog',
    name: 'en-blogs',
    meta: meta(
      'WhatsApp Aero Blog – Guides, Tips & Latest Updates',
      'Explore WhatsApp Aero blog for the latest guides, installation tips, update tutorials, feature breakdowns, and comparisons to help you get the most out of WhatsApp Aero.',
      '',
      '/blog/'
    ),
    component: () => import('@/views/blogs.vue'),
  },
  {
    path: '/blog/whatsapp-vs-aero',
    name: 'en-blog-vs-wa',
    meta: meta(
      'WhatsApp Aero vs Official WhatsApp – Full Comparison',
      'Compare WhatsApp Aero with official WhatsApp. Discover differences in privacy, customization, media sharing, and user control features.',
      'WhatsApp Aero vs WhatsApp, Comparison WhatsApp Aero, WhatsApp Aero Features vs WhatsApp',
      '/blog/whatsapp-vs-aero/'
    ),
    component: () => import('@/views/blog-whatsapp-vs-aero.vue'),
  },
  {
    path: '/blog/aero-vs-gbwhatsapp',
    name: 'en-blog-vs-gb',
    meta: meta(
      'WhatsApp Aero vs GB WhatsApp – Which Is Better?',
      'Detailed comparison between WhatsApp Aero and GB WhatsApp including features, performance, customization, and stability.',
      'WhatsApp Aero vs GB WhatsApp, GB WhatsApp comparison, WhatsApp mods comparison',
      '/blog/aero-vs-gbwhatsapp/'
    ),
    component: () => import('@/views/blog-aero-vs-gb.vue'),
  },
  {
    path: '/blog/ios',
    name: 'en-blog-ios',
    meta: meta(
      'WhatsApp Aero for iOS – Is It Available or Not?',
      'Learn whether WhatsApp Aero works on iPhone and explore safe alternatives for iOS users with similar customization features.',
      'WhatsApp Aero iOS, WhatsApp Aero iPhone, WhatsApp Aero for iPhone alternative',
      '/blog/ios/'
    ),
    component: () => import('@/views/blog-ios.vue'),
  },
  {
    path: '/disclaimer',
    name: 'en-disclaimer',
    meta: meta(
      'Disclaimer – WhatsApp Aero Information Notice',
      'This page explains the disclaimer for this website. All information about WhatsApp Aero is provided for educational purposes only, and we are not affiliated with the official app or its developers.',
      '',
      '/disclaimer/'
    ),
    component: () => import('@/views/disclaimer.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'en-privacy',
    meta: meta(
      'Privacy Policy – WhatsApp Aero Guide Website',
      'Learn how this website handles user data, cookies, and third-party links. We do not collect personal information and only use basic analytics to improve user experience.',
      '',
      '/privacy-policy/'
    ),
    component: () => import('@/views/privacy.vue'),
  },
  {
    path: '/privacy',
    redirect: '/privacy-policy',
  },
  {
    path: '/terms',
    name: 'en-terms',
    meta: meta(
      'Terms & Conditions',
      'Read the terms and conditions for using this website. By accessing this site, you agree to the rules regarding content usage, responsibility, and external links.',
      '',
      '/terms/'
    ),
    component: () => import('@/views/terms.vue'),
  },
];

export default function createRouter() {
  return new VueRouter({
    mode: 'history',
    routes: constRoutesPc,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) return savedPosition;
      return { x: 0, y: 0 };
    },
  });
}
